const customersReviewsData = [
    {
        nome: 'Marcela',
        texto: 'Simplesmente sensacional! Sabor sempre o mesmo. O que é difícil principalmente por se tratar de hambúrguer artesanal. Vale a pena.',
        sexo: 'feminino'
    },
    {
        nome: 'Ronny',
        texto: 'Um dos melhores hambúrguer realmente artesanais que eu já comi, hambúrguer feito na hora, saladas frescas e pão artesanal. Meus parabéns gosto delicioso.',
        sexo: 'masculino'
    },
    {
        nome: 'Timóteo',
        texto: 'Adorei as bebidas naturais. Fazem uma série de misturas que chamam muito a atenção e surpreendem. Sensacional!',
        sexo: 'masculino'
    },
    {
        nome: 'Joana Costa',
        texto: 'Não sou de deixar elogios em pedidos que faço, mas estou super satisfeita com a comida e o atendimento prestado pela Food. Recomendo!',
        sexo: 'masculino'
    },
    {
        nome: 'Carlos Santos',
        texto: 'Acabei de comer o sanduíche, foi espetacular, parabéns! Muito obrigado por proporcionar uma experiência desta.',
        sexo: 'masculino'
    },
]

export default customersReviewsData 